import { t as e } from "../../chunks/cn.CnaYSZq4.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region lib/Factbox/components/FactboxHeaderItem.tsx
var r = ({ icon: r, title: i, className: a, onMouseDown: o, children: s }) => {
	let c = o ? "hover:bg-slate-300 dark:hover:bg-slate-500" : "";
	return /* @__PURE__ */ n("div", {
		contentEditable: !1,
		className: e("h-7 w-7 rounded flex flex-row gap-2 items-center justify-center", a),
		onMouseDown: o,
		title: i,
		children: [r && /* @__PURE__ */ t("div", {
			className: e("p-1 rounded", c),
			children: /* @__PURE__ */ t(r.icon, {
				className: r.className,
				size: 15
			})
		}), s]
	});
};
//#endregion
export { r as FactboxHeaderItem };
